import { Chip, keyframes, Stack } from '@rossum/ui/material';
import { useState } from 'react';

const spinKeyframes = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const flashKeyframes = keyframes`
  0% { background: #EF4444; }
  25% { background: #F59E0B; }
  50% { background: #10B981; }
  75% { background: #3B82F6; }
  100% { background: #8B5CF6; }
`;

const glowKeyframes = keyframes`
  0% { box-shadow: 0 0 10px -10px #aef4af; }
  100% { box-shadow: 0 0 10px 10px #aef4af; }
`;

const gradientKeyframes = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const PartyLabelChip = ({ name }: { name: string }) => {
  const [party, setParty] = useState(false);

  return (
    <Stack
      spacing={2}
      sx={{ alignItems: 'center' }}
      onMouseEnter={() => setParty(true)}
      onMouseLeave={() => setParty(false)}
    >
      <Chip
        label={name}
        sx={{
          backgroundSize: '1200% 1200%',
          backgroundImage:
            'linear-gradient(70deg, #ff0000, #ff8c00, #ffff00, #32cd32, #00ced1, #1e90ff, #8a2be2, #ff1493, #ff69b4, #ffa500, #00ff7f, #7fffd4)',
          animation: party
            ? `${spinKeyframes} 1s linear infinite, ${flashKeyframes} 1s ease-in-out infinite, ${glowKeyframes} 0.5s infinite alternate`
            : `${gradientKeyframes} 3s ease infinite`,
        }}
      />
    </Stack>
  );
};
